import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatOption, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { CustomerSearch } from '../models/customer-search';
import { KycMonitoringFilter } from '../models/kyc-monitoring-filter';
import { KycMonitoringSearch } from '../models/kyc-monitoring-search';
import { KycAdverseSearch } from '../models/kyc-adverse-search';
import { CustomerService } from '../services/customer.service';
import { KycMonitoringService } from '../services/kyc-monitoring.service';
import { saveAs } from "file-saver";
import { ApiSettingService } from "../services/api-setting.service";
import { ApiSetting } from "../models/api-setting";
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-aml-sanctions',
  templateUrl: './aml-sanctions.component.html',
  styleUrls: ['./aml-sanctions.component.scss']
})
export class AmlSanctionsComponent implements OnInit, AfterViewInit {

  @ViewChild(MatSort, { read: false }) sort: MatSort;
  @ViewChild('adverseSort', { read: false }) adverseSort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild('allSelected') private allSelected: MatOption;
  @ViewChild('allSelectedAml') private allSelectedAml: MatOption;
  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    this.tableDataSource.paginator = paginator;
  }
  @ViewChild('adversePaginator') set adversePaginator(paginator: MatPaginator) {
    this.adverseTableDataSource.paginator = paginator;
  }

  form: FormGroup;
  customers = new Array<CustomerSearch>();
  kycMonitoringSearch = new Array<KycMonitoringSearch>();
  adverseMonitoringSearch = new Array<KycAdverseSearch>();
  tableDataSource = new MatTableDataSource<KycMonitoringSearch>();
  adverseTableDataSource = new MatTableDataSource<KycAdverseSearch>();
  searching = true;
  displayedColumns = ['customerName', 'amlProvider', 'apiCallsIncluded', 'montlyFee', 'feeExtraApiCall', 'currentPeriodUsage', 'totalToPay'];
  adverseDisplayedColumns = ['customerName', 'amlProvider', 'feeExtraApiCall', 'currentPeriodUsage', 'totalToPay'];
  apiSettings = new Array<ApiSetting>();

  constructor(
    private fb: FormBuilder,
    private customerService: CustomerService,
    private kycMonitoringService: KycMonitoringService,
    private apiSettingService: ApiSettingService,
  ) { }

  ngAfterViewInit(): void {
    this.tableDataSource.sort = this.sort;
    if (this.adverseSort) {
      this.adverseTableDataSource.sort = this.adverseSort;
    }
  }

  ngOnInit() {
    this.getAllCustomers();
    this.form = this.createForm();
    this.apiSettingService.getByType('AML').subscribe(apiSettings => {
      this.apiSettings = apiSettings;
    });
  }


  getAllCustomers() {
    this.customerService.getAll()
      .subscribe((customers) => {
        this.customers = customers;
        this.filter();
      }, err => {
      });
  }

  tosslePerOneAml() {
    if (this.allSelectedAml.selected) {
      this.allSelectedAml.deselect();
      return false;
    }
    if (this.form.controls.aml.value.length === this.apiSettings.length) {
      this.allSelectedAml.select();
    }
  }

  toggleAllSelectionAml() {
    if (this.allSelectedAml.selected) {
      this.form.controls.aml
        .patchValue(this.apiSettings.map(item => item.id));
      this.allSelectedAml.select();
    } else {
      this.form.controls.aml.patchValue([]);
    }
  }

  tosslePerOne() {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }
    if (this.form.controls.customer.value.length === this.customers.length) {
      this.allSelected.select();
    }
  }

  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.form.controls.customer
        .patchValue(this.customers.map(item => item.id));
      this.allSelected.select();
    } else {
      this.form.controls.customer.patchValue([]);
    }
  }

  exportAsExcel(detailed: boolean) {
    let filter: KycMonitoringFilter;
    filter = (this.form.getRawValue() as KycMonitoringFilter);
    filter.isDetailed = detailed;
    if (filter.aml) {
      filter.aml = filter.aml.filter(value => value != null);
    }
    this.searching = true;

    this.kycMonitoringService.export(filter)
      .subscribe((data) => {
        this.searching = false;
        saveAs(data, 'KycMonitoringExportDetailed.xlsx');
      }, err => {
        this.searching = false;
        console.log(err);
      });
  }

  filter() {
    this.searching = true;
    let filter: KycMonitoringFilter;
    filter = (this.form.getRawValue() as KycMonitoringFilter);
    if (filter.aml) {
      filter.aml = filter.aml.filter(value => value != null);
    }

    forkJoin([
      this.kycMonitoringService.search(filter),
      this.kycMonitoringService.searchAdverse(filter)
    ]).subscribe(([aml, adverse]) => {
      this.kycMonitoringSearch = aml;
      this.tableDataSource.data = aml;
      this.adverseMonitoringSearch = adverse;
      this.adverseTableDataSource.data = adverse;
      this.searching = false;
    }, err => {
      this.searching = false;
    });
  }

  clearFilter() {
    this.form = this.createForm();
    this.filter();
  }

  createForm(): FormGroup {
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    return this.fb.group({
      aml: [[]],
      customer: [[]],
      startDate: [firstDay],
      endDate: [lastDay],
    });
  }
}
